const confirmViewRemainingBalanceReducer = (state = '', action) => {
	switch(action.type){
	case 'CONFIRMVIEWREMAININGBALANCECHANGE':
		return action.payload;
	default:
		return state;
	}
}

export default confirmViewRemainingBalanceReducer;